import * as api from "app/api/oauth"
import * as token from "app/localStorage/token"
import AccessToken from "app/models/accessToken"
import { CurrentToken } from "app/models/user"
import { SagaIterator } from "redux-saga"
import { call, put, takeLatest } from "redux-saga/effects"
import { isAccessTokenExpired, parseToken } from "utils"
import { getCurrentUserFlow } from "../currentUser/currentUser.saga"
import * as actions from "./authorization.actions"
import { handleError } from "../errorHandler/errorHandler.saga"

export function* authorizationFlow(action?: actions.AuthorizeAction): SagaIterator {
  try {
    const accessToken = yield call(token.getAccessToken)
    if (accessToken) {
      const t: AccessToken = yield call(parseToken, accessToken)
      const expired: boolean = yield call(isAccessTokenExpired, t)
      if (expired) {
        yield call(refreshFlow)
        return
      }
      if (action?.payload) {
        const { payload } = action
        yield call(api.authorize, payload)
      }
      yield put(actions.authorizeSuccess(accessTokenToUser(t)))
      yield call(getCurrentUserFlow)
      return
    }
    yield call(api.authorize)
  } catch (e) {
    yield call(api.authorize)
    yield put(actions.authorizeFail(e))
    yield call(handleError, { error: e })
  }
}

export function* refreshFlow(): SagaIterator {
  try {
    const newToken = yield call(api.refresh)
    yield call(token.storeAccessToken, newToken && newToken.accessToken)
    yield call(token.storeIdToken, newToken && newToken.idToken)
    const newParsedToken = yield call(parseToken, newToken.accessToken)
    yield put(actions.authorizeSuccess(accessTokenToUser(newParsedToken)))
    yield call(getCurrentUserFlow)
    return
  } catch (e) {
    yield call(api.authorize)
    yield put(actions.authorizeFail(e))
    yield call(handleError, { error: e })
  }
}

export default function* authorizationSaga(): SagaIterator {
  yield takeLatest(actions.Types.AUTHORIZE, authorizationFlow)
}

export function accessTokenToUser(t: AccessToken): CurrentToken {
  return {
    id: t.sub,
    roles: t["https://ppt/activeGroup"].roles,
    system_roles: t["https://ppt/activeGroup"].system_roles,
  }
}
